// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IUndergroundDtoForOfferSnippetSchema {
  /** Тип метро по городам (например, mow) **/
  cityType?: ECityType;
  /** Цвет линии метро **/
  lineColor?: string;
  /** Название метро **/
  name?: string;
  /** Время до метро строкой **/
  timeDisplay: string;
  /** Способ передвижения **/
  transportType: ETransportType;
}

export enum ECityType {
  /** Екатеринбург **/
  'Ekb' = 'Ekb',
  /** Казань **/
  'Kazan' = 'Kazan',
  /** Москва **/
  'Msk' = 'Msk',
  /** Нижний новгород **/
  'Nizhniy' = 'Nizhniy',
  /** Новосибирск **/
  'Novosib' = 'Novosib',
  /** Самара **/
  'Samara' = 'Samara',
  /** Санкт-Петербург **/
  'Spb' = 'Spb',
}
export enum ETransportType {
  /** Транспортом **/
  'Transport' = 'transport',
  /** Пешком **/
  'Walk' = 'walk',
}
